module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("Payment method")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "pmt-cc"
    }
  }, [_c('input', {
    staticClass: "pmt-type",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.account_type === _vm.credit_card
    },
    on: {
      "input": function($event) {
        return _vm.setAccountType(_vm.credit_card)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Credit card")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "pmt-ach"
    }
  }, [_c('input', {
    staticClass: "pmt-type",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.account_type === _vm.ach
    },
    on: {
      "input": function($event) {
        return _vm.setAccountType(_vm.ach)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bank / ACH")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0741c2fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewPaymentMethodSelect.vue
// module id = 1303
// module chunks = 16